import React from "react";

export const SvgVillType = (props: any) => {
	return (
		<svg
			width="18"
			height="16"
			viewBox="0 0 18 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M17.7604 8.58521L13.6364 4.46157V0.982279C13.6364 0.530424 13.2701 0.164097 12.8182 0.164097C12.3664 0.164097 12 0.530424 12 0.982279V2.82532L9.57822 0.40366C9.25875 0.0841875 8.74067 0.0841874 8.4212 0.403715L0.239646 8.58527C-0.0798819 8.90474 -0.0798819 9.42281 0.239646 9.74234C0.399409 9.9021 0.608755 9.98201 0.818155 9.98201C1.02756 9.98201 1.23696 9.9021 1.39666 9.74234L2.7273 8.41176V14.6187C2.7273 15.0705 3.09363 15.4368 3.54549 15.4368H7.36367H10.6364H14.4546C14.9064 15.4368 15.2728 15.0705 15.2728 14.6187V8.41187L16.6034 9.7424C16.9228 10.0619 17.4409 10.0618 17.7604 9.74234C18.08 9.42276 18.0799 8.90474 17.7604 8.58521ZM8.18185 13.8005V10.5277H9.81822V13.8005H8.18185ZM13.6364 13.8005H11.4546V9.70956C11.4546 9.2577 11.0883 8.89138 10.6364 8.89138H7.36367C6.91182 8.89138 6.54549 9.2577 6.54549 9.70956V13.8005H4.36367V6.77539L8.99976 2.13935L13.6364 6.77567V13.8005Z"
				fill="#666666"
				{...props}
			/>
		</svg>
	);
};
